import React from 'react';
import { Badge, Button } from 'react-bootstrap';
import i18n from 'i18n';
import { useTranslation } from 'react-i18next';
import MixpanelService from '../../../utils/mixpanelService';
import SimpleLoader from '../../loaders/SimpleLoader';
import styles from './DataDefinitionButton.module.css';
import clsx from 'clsx';

interface DataDefinitionButtonProps {
  onClick(): void;
  paramCount: number | undefined;
  isLoading: boolean;
}

const DataDefinitionButton = (props: DataDefinitionButtonProps) => {
  const numberOfDDParams = props.paramCount ? props.paramCount : 0;
  const { t } = useTranslation('common');

  const numberOfParametersBadge = () => {
    return !props.isLoading ? (
      <Badge
        variant="secondary"
        className={clsx('ml-1', styles.dataBadge)}
        data-parameters="ddPanelButtonBadge"
        title={t('tdm.noOfParamsDefined', {
          count: numberOfDDParams,
        })}
      >
        {numberOfDDParams}
      </Badge>
    ) : props.isLoading ? (
      <SimpleLoader style={{ display: 'inline' }} showLoadingText={false} loaderSize={15} />
    ) : null;
  };

  const onClick = () => {
    MixpanelService.track({
      event: 'blazedata_panel_toggle',
      metadata: {
        type: 'Virtual Services',
      },
    });
    props.onClick();
  };

  return (
    <Button
      disabled={props.isLoading}
      id={'qa-dd-panel-toggle'}
      className={'ml-5'}
      variant="secondary"
      onClick={onClick}
    >
      {i18n.t('common:tdm.serviceData')} {numberOfParametersBadge()}
    </Button>
  );
};

export default DataDefinitionButton;
